import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';
import { TransparentButton, Button, ButtonType } from '@checkmarx/cx-ui';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import classNames from 'classnames';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'adminConfigurationStore') @observer
export default class TwoFactorAuthSettings extends Component {

    confStore = this.props.adminConfigurationStore;
    t = this.props.translationsStore;

    componentDidMount() {
        this.confStore.getTwoFactorSettings();
    }

    toggleMandateTwoFA = e => {
        this.confStore.toggleMandateTwoFA()
    };

    handleRecoveryCountChange = e => this.confStore.setRecoveryCodeCount(e.target.value);
    handleRecoveryCountOnBlur = e => this.confStore.validateRecoveryCodeCount();

    handleSubmitForm = (e) => {
        e.preventDefault();

        const isValid = this.confStore.validateTwoFactorSettingForm();

        if (isValid === false) {
            return;
        }

        this.confStore.setTwoFactorSettings().then((response) => {
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('TWOFACTOR_AUTH_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({ level, message });
        });
    }

    fieldWidth = '48%';


    render() {
        return (
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <div className="setting-sub-title">
                        {this.t.translate('MFA_AUTH_SUB_TITLE')}
                    </div>
                    <div className='ldap-server-settings-form-main-wrapper'>
                        <div className='form-row start'>
                            <PortalTextBox
                                dataCy={'txt-recovery-code-count'}
                                hintText={this.t.translate('RECOVERY_CODE_COUNT')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('RECOVERY_CODE_COUNT')}
                                    required={true} />}
                                onChange={this.handleRecoveryCountChange}
                                onBlur={this.handleRecoveryCountOnBlur}
                                width={this.fieldWidth}
                                errorText={this.confStore.recoveryCodeCountValidationMessage}
                                disabled={this.confStore.updateInProgress}
                                value={this.confStore.recoveryCodeCount}
                            />
                        </div>
                        <div className='form-row start' style={{ paddingTop:'40px' }}>
                            <PortalCheckBox
                                dataCy={'tgl-enforce-twofactor-auth'}
                                dataKey={'enforceTwoFactorAuth'}
                                checked={this.confStore.twoFAEnforced}
                                onCheck={this.toggleMandateTwoFA}
                                disabled={this.confStore.updateInProgress}
                                label={this.t.translate('MANDATE_TWO_FA')}
                                />
                        </div>
                        
                    </div>
                    <div className='general-settings-submit'>
                        <Button
                            dataCy='btn-lockout-options-submit'
                            type='submit'
                            inProgress={this.confStore.stepInProgress}
                            text={this.props.translationsStore.translate('SAVE')} >
                        </Button>
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/security/twoFactorAuthSettings/index.jsx